import "./crypto.styles.css";

import { useState, useEffect } from "react";
import { Header } from "./components/header-new/header";

import cryptobg from "./asset-source/Crypt-wjet-header-1.jpg";
import checkmark from "./asset-source/checkmark-white.png";

import cryptobgmobile from "./asset-source/Crypt-mobile-wjet-header-1.jpg";
import success from "./asset-source/success.png";
import { Footer } from "./components/footer/footer";

function CryptoEmailsPage() {
	const [isMenuActive, setIsMenuActive] = useState(false);
	const [currentField, setCurrentField] = useState("");
	const [nameUser, setNameUser] = useState("");
	const [contacts, setContact] = useState("");
	const [checkbox, setCheckbox] = useState(true);
	const [modal, setModal] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);

	function functionname() {
		var ajax = new XMLHttpRequest();
		// var data = document.getElementById("form");
		// var formdata = new FormData(data);
		var formdata = new FormData();
		formdata.append("fname", nameUser);
		formdata.append("email", contacts);
		formdata.append("info", textfield);
		// formdata.append("source", listId);
		// formdata.append("not_doi", 1);

		var object = {};
		formdata.forEach(function (value, key) {
			object[key] = value;
		});
		var json = JSON.stringify(object);

		ajax.open("POST", `https://wjet.io/api/telegram/log`, true);
		ajax.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
		// ajax.setRequestHeader("Access-Control-Allow-Origin", "*");

		ajax.send(json);

		window.gtag("event", "conversion", {
			send_to: "AW-16987029684/2ZrnCL-L3bUaELSBhqQ_",
		});
	}

	useEffect(() => {
		if (modal || isMenuActive) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}
	}, [modal, isMenuActive]);

	return (
		<div
			className="App crypto cryptoemail"
			onClick={() => {
				setCurrentField("");
			}}
		>
			<Header
				onLight
				isTitlePage
			/>

			<section
				className="mainpage__top"
				id="top"
			>
				<img
					src={cryptobg}
					alt=""
					className="cryptobg"
				/>
				<img
					src={cryptobgmobile}
					alt=""
					className="cryptobgmobile"
				/>

				<div className="container">
					<div className="maingrid">
						<div>
							<div className="emailbanner">Бесплатные рекомендации</div>
							<h1 className="h1 h1--email">
								4&nbsp;фатальных ошибки при&nbsp;проектировании{" "}
								<span>web3&nbsp;проектов</span>, которые будут стоить
								вам&nbsp;времени, денег, клиентов и&nbsp;репутации
							</h1>
							<p className="top__text">
								Мы <span className="accenttext">бесплатно</span> отправим вам
								ссылку на статью. И полезные письма будем отправлять не чаще
								одного раза в месяц.
							</p>
						</div>

						<form
							action=""
							className="modal__body"
							id="form"
							method="post"
							onSubmit={(e) => {
								e.preventDefault();
								setCurrentField("");
								functionname();
								setNameUser("");
								setContact("");
								setTextfield("");
							}}
							// onSubmit={handleClose}
							// target="_blank"
						>
							{isSuccess ? (
								<div className="success__container">
									<img
										src={success}
										alt=""
										className="successicon"
									/>
									<div className="successtitle">Проверьте почту!</div>
									<div>
										Если письмо не пришло в течение пары минут, проверьте папку{" "}
										<b>Спам</b> и <b>Промоакции</b>.
									</div>
									<a
										href="/"
										className="success__homelink"
									>
										Перейти на главную
									</a>
								</div>
							) : (
								<>
									<div
										className={
											currentField === "name"
												? "focused crypto__forminput"
												: "crypto__forminput"
										}
									>
										<div>Ваше имя</div>
										<input
											name="FNAME"
											id="mce-FNAME"
											type="text"
											className="input"
											placeholder="Ваше имя"
											onClick={(e) => {
												e.stopPropagation();
												setCurrentField("name");
											}}
											onInput={(e) => {
												setNameUser(e.target.value);
											}}
											required
											value={nameUser}
										/>
									</div>

									<div
										className={
											currentField === "contact"
												? "focused crypto__forminput"
												: "crypto__forminput"
										}
									>
										<div>Ваша почта</div>
										<input
											name="EMAIL"
											id="mce-EMAIL"
											type="text"
											className="input"
											placeholder="Почта"
											onClick={(e) => {
												e.stopPropagation();
												setCurrentField("contact");
											}}
											onInput={(e) => {
												setContact(e.target.value);
											}}
											required
											value={contacts}
										/>
									</div>

									<div
										className={
											checkbox ? "checked cryptocheckbox" : "cryptocheckbox"
										}
										onClick={() => setCheckbox(!checkbox)}
									>
										<div className="chb">
											<img
												src={checkmark}
												alt=""
											/>
										</div>
										<div>Хочу получать проверенные советы и лайфхаки</div>
										<input
											name="SUBS"
											id="mce-SUBS"
											type="text"
											value={checkbox ? "true" : "false"}
											style={{
												visibility: "hidden",
												display: "none",
											}}
										/>
									</div>

									<button
										className="btn action"
										type="submit"
									>
										Получить материал
									</button>
								</>
							)}
						</form>
					</div>
				</div>
			</section>

			<section className="footersection">
				<div className="container">
					<Footer backgroundColor="transparent" />
				</div>
			</section>
		</div>
	);
}

export default CryptoEmailsPage;
